type DefaultConfiguration = {
	// Enables streaming mode for react-resource-router
	streaming: boolean;
};

export const defaultConfiguration: DefaultConfiguration = {
	streaming: false,
};
